
const API_BASE = 
  import.meta.env?.VITE_API_BASE_URL || 
  process.env?.REACT_APP_API_BASE || 
  'http://localhost:10000';export function getToken() {
  return localStorage.getItem('token');
}

export function isLoggedIn() {
  return !!getToken();
}

export function notesFromServer(serverNotes) {
  if (!Array.isArray(serverNotes)) return [];

  return serverNotes
    .map((n) => {
      const raw = typeof n?.content === 'string' ? n.content : '';
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch {
        // ignore
      }
      return null;
    })
    .filter(Boolean);
}

export function notesToServer(notes) {
  if (!Array.isArray(notes)) return [];
  return notes
    .map((n) => {
      const clientId = String(n?.id ?? '');
      if (!clientId) return null;
      return {
        clientId,
        content: JSON.stringify(n),
        updatedAt: n?.updatedAt || n?.createdAt || new Date().toISOString(),
      };
    })
    .filter(Boolean);
}

function safeSet(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn('localStorage setItem failed for', key, e?.name || e);
    return false;
  }
}

export function cacheUserDataToLocalStorage(userData) {
  if (!userData || typeof userData !== 'object') return;

  // Keep a raw copy too
  safeSet('userData', JSON.stringify(userData));

  if (typeof userData.username === 'string') safeSet('anotequest_username', userData.username);
  if (userData.stats) safeSet('anotequest_stats', JSON.stringify(userData.stats));
  if (Array.isArray(userData.folders)) safeSet('anotequest_folders', JSON.stringify(userData.folders));
  if (Array.isArray(userData.notes)) safeSet('anotequest_notes', JSON.stringify(userData.notes));
  if (Array.isArray(userData.images)) safeSet('anotequest_images', JSON.stringify(userData.images));
  if (Array.isArray(userData.note_stickers)) safeSet('anotequest_note_stickers', JSON.stringify(userData.note_stickers));
  if (Array.isArray(userData.todos)) safeSet('anotequest_todos', JSON.stringify(userData.todos));
  if (Array.isArray(userData.characters)) safeSet('anotequest_characters', JSON.stringify(userData.characters));
  if (Array.isArray(userData.sources)) safeSet('anotequest_sources', JSON.stringify(userData.sources));
  if (typeof userData.theme === 'string') safeSet('theme', userData.theme);

  // Optional extra keys if present
  if (Array.isArray(userData.stickers)) safeSet('anotequest_stickers', JSON.stringify(userData.stickers));
  if (Array.isArray(userData.tables)) safeSet('anotequest_tables', JSON.stringify(userData.tables));
  if (Array.isArray(userData.drawings)) safeSet('anotequest_drawings', JSON.stringify(userData.drawings));
  if (Array.isArray(userData.trash)) safeSet('anotequest_trash', JSON.stringify(userData.trash));
}

export async function login(username, password) {
  const res = await fetch(`${API_BASE}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || 'Login failed');
  return data;
}

export async function signup(username, password) {
  const res = await fetch(`${API_BASE}/api/auth/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || 'Signup failed');
  return data;
}

export async function getUserData() {
  const token = getToken();
  if (!token) throw new Error('Missing token');

  const res = await fetch(`${API_BASE}/api/userdata`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || 'Failed to load userData');
  return data?.userData;
}

export async function saveUserData(userData) {
  const token = getToken();
  if (!token) throw new Error('Missing token');

  const res = await fetch(`${API_BASE}/api/userdata`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userData }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || 'Failed to save userData');
  return data?.userData;
}

export async function syncAll(notes) {
  const token = getToken();
  if (!token) throw new Error('Missing token');

  const res = await fetch(`${API_BASE}/api/sync-all`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ notes: notesToServer(notes) }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || 'Sync failed');
  }
}
